import { environment } from 'src/environments/environment';

export const LOOPBACK_URL = environment.apiUrl.hostName;

export interface ApiUrl {
  hirePurchaseDetail: string;
  emergencyContact: string;
  currentEmploymentDetail: string;
  pastEmploymentDetail: string;
  user: string;
  code: string;
  financialDetail: string;
  documentCheckList: string;
  agentList: string;
  clientDefault: string;
  address: string;
  clientAddress: string;
  productLoan: string;
  hirePurchaseProduct: string;
  hirePurchaseLoanDetail: string;
  onboardingDraft: string;
  guarantor: string;
  drawdown: string;
  guarantorFinancialDetail: string;
  social: string;
  ctos: string;
  portfolioCommandSource: string;
  guarantorConsent: string;
  ringgitPay: string;
  //loanApplication: string;
  company: string;
  creditLimits: string;
  documentChecklist: string;
  loanProduct: string;
  repayment: string;
  statement: string;
  termLoanAgreement: string;
  creditFacilityAgreement: string;
  termLoanEmail: string;
  creditFacilityEmail: string;
  guarantorAgreement: string;
  guarantorAgreementForCreditFacility: string;
  signature: string;
  appVersion: string;
  singpass: string;
  appVersions: string;
  myInfo: string;
  myInfoPersonalProfile: string;
  myInfoBusProfile: string;
  myInfoAdditionalInfo: string;
  siteVisit: string;
  loanClient: string;
  //userProfile: string;
  mikrokreditUserProfile: string;
  mikrokreditLoan: string;
  consentReg: string;
  ambankstatus: string;
  autoDebitAcceptance: string;
  office: string;
  auth: string;
  globalConfiguration: string;
  appSettings: string;
  clientSupport: string;
  playIntegrity: string;
  earlySettlement: string;
  ekyc: string;
  recaptcha: string;
}

// When endpoint is local environment
export const API_URL: ApiUrl = {
  hirePurchaseDetail: LOOPBACK_URL + environment.apiUrl.apiPath.hirePurchase,
  emergencyContact: LOOPBACK_URL + environment.apiUrl.apiPath.emergencyContact,
  currentEmploymentDetail: LOOPBACK_URL + environment.apiUrl.apiPath.currentEmploymentDetail,
  pastEmploymentDetail: LOOPBACK_URL + environment.apiUrl.apiPath.pastEmploymentDetail,
  user: LOOPBACK_URL + environment.apiUrl.apiPath.userProfiles,
  code: LOOPBACK_URL + environment.apiUrl.apiPath.code,
  financialDetail: LOOPBACK_URL + environment.apiUrl.apiPath.financialDetail,
  documentCheckList: LOOPBACK_URL + environment.apiUrl.apiPath.documentCheckList,
  agentList: LOOPBACK_URL + environment.apiUrl.apiPath.agentList,
  clientDefault: LOOPBACK_URL + environment.apiUrl.apiPath.clientDefault,
  address: LOOPBACK_URL + environment.apiUrl.apiPath.address,
  clientAddress: LOOPBACK_URL + environment.apiUrl.apiPath.clientAddress,
  productLoan: LOOPBACK_URL + environment.apiUrl.apiPath.productLoan,
  hirePurchaseProduct: LOOPBACK_URL + environment.apiUrl.apiPath.hirePurchaseProduct,
  hirePurchaseLoanDetail: LOOPBACK_URL + environment.apiUrl.apiPath.hirePurchaseLoanDetail,
  onboardingDraft: LOOPBACK_URL + environment.apiUrl.apiPath.onboardingDraft,
  guarantor: LOOPBACK_URL + environment.apiUrl.apiPath.guarantor,
  drawdown: LOOPBACK_URL + environment.apiUrl.apiPath.drawdown,
  guarantorFinancialDetail: LOOPBACK_URL + environment.apiUrl.apiPath.guarantorFinancialDetail,
  social: LOOPBACK_URL + environment.apiUrl.apiPath.social,
  ctos: LOOPBACK_URL + environment.apiUrl.apiPath.ctos,
  portfolioCommandSource: LOOPBACK_URL + environment.apiUrl.apiPath.portfolioCommandSource,
  guarantorConsent: LOOPBACK_URL + environment.apiUrl.apiPath.guarantorConsent,
  ringgitPay: LOOPBACK_URL + environment.apiUrl.apiPath.ringgitPay,
  //loanApplication: LOOPBACK_URL+environment.apiUrl.apiPath.loanApplication,
  company: LOOPBACK_URL + environment.apiUrl.apiPath.company,
  creditLimits: LOOPBACK_URL + environment.apiUrl.apiPath.creditLimits,
  documentChecklist: LOOPBACK_URL + environment.apiUrl.apiPath.documentCheckList,
  loanProduct: LOOPBACK_URL + environment.apiUrl.apiPath.loanProduct,
  repayment: LOOPBACK_URL + environment.apiUrl.apiPath.repayment,
  statement: LOOPBACK_URL + environment.apiUrl.apiPath.statement,
  termLoanAgreement: LOOPBACK_URL + environment.apiUrl.apiPath.termLoanAgreement,
  creditFacilityAgreement: LOOPBACK_URL + environment.apiUrl.apiPath.creditFacilityAgreement,
  termLoanEmail: LOOPBACK_URL + environment.apiUrl.apiPath.termLoanEmail,
  creditFacilityEmail: LOOPBACK_URL + environment.apiUrl.apiPath.creditFacilityEmail,
  signature: LOOPBACK_URL + environment.apiUrl.apiPath.signature,
  guarantorAgreement: LOOPBACK_URL + environment.apiUrl.apiPath.guarantorAgreement,
  guarantorAgreementForCreditFacility: LOOPBACK_URL + environment.apiUrl.apiPath.guarantorAgreementForCreditFacility,
  appVersion: LOOPBACK_URL + environment.apiUrl.apiPath.appVersion,
  singpass: LOOPBACK_URL + environment.apiUrl.apiPath.singpass,
  appVersions: LOOPBACK_URL + environment.apiUrl.apiPath.appVersions,
  myInfo: LOOPBACK_URL + environment.apiUrl.apiPath.myInfo,
  myInfoPersonalProfile: LOOPBACK_URL + environment.apiUrl.apiPath.myInfoPersonalProfile,
  myInfoBusProfile: LOOPBACK_URL + environment.apiUrl.apiPath.myInfoBusProfile,
  myInfoAdditionalInfo: LOOPBACK_URL + environment.apiUrl.apiPath.myInfoAdditionalInfo,
  //userProfile: LOOPBACK_URL + environment.apiUrl.apiPath.userProfiles
  siteVisit: LOOPBACK_URL + environment.apiUrl.apiPath.siteVisit,
  loanClient:LOOPBACK_URL + environment.apiUrl.apiPath.loanClient,
  mikrokreditUserProfile: LOOPBACK_URL + environment.apiUrl.apiPath.mikrokreditUserProfile,
  mikrokreditLoan: LOOPBACK_URL + environment.apiUrl.apiPath.mikrokreditLoan,
  consentReg: LOOPBACK_URL + environment.apiUrl.apiPath.consentReg,
  ambankstatus: LOOPBACK_URL + environment.apiUrl.apiPath.ambankstatus,
  autoDebitAcceptance: LOOPBACK_URL + environment.apiUrl.apiPath.autoDebitAcceptance,
  office: LOOPBACK_URL + environment.apiUrl.apiPath.office,
  auth: LOOPBACK_URL + environment.apiUrl.apiPath.auth,
  globalConfiguration: LOOPBACK_URL + environment.apiUrl.apiPath.globalConfiguration,
  clientSupport: LOOPBACK_URL + environment.apiUrl.apiPath.clientSupport,
  playIntegrity: LOOPBACK_URL + environment.apiUrl.apiPath.playIntegrityCheck,
  earlySettlement: LOOPBACK_URL + environment.apiUrl.apiPath.earlySettlement,
  ekyc: LOOPBACK_URL + environment.apiUrl.apiPath.ekyc,
  recaptcha: LOOPBACK_URL + environment.apiUrl.apiPath.recaptcha,
  appSettings: LOOPBACK_URL + environment.apiUrl.apiPath.appSettings
};
